// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */

import * as DecidrNodeId from "../../node-id/src/DecidrNodeId.bs.js";
import * as RescriptRelay from "rescript-relay/src/RescriptRelay.bs.js";
import * as RescriptRelay_Internal from "rescript-relay/src/RescriptRelay_Internal.bs.js";

var Types = {};

function unwrap_response_createChannel_channel_channelType(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["ResourceChannel"]);
}

function unwrap_rawResponse_createChannel_channel_channelType_ResourceChannel_appResource_resourceType(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "CellResource",
              "Column",
              "ColumnView",
              "Row",
              "RowView",
              "Table",
              "View"
            ]);
}

function unwrap_rawResponse_createChannel_channel_channelType(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["ResourceChannel"]);
}

var variablesConverter = {"__root":{"resourceId":{"c":"DecidrNodeId.RelayAppSync"},"organizationId":{"c":"DecidrNodeId.RelayAppSync"}}};

var variablesConverterMap = {
  "DecidrNodeId.RelayAppSync": DecidrNodeId.RelayAppSync.serialize
};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, variablesConverterMap, undefined);
}

var wrapResponseConverter = {"__root":{"createChannel_channel_numberOfUnreadMessages":{"b":""},"createChannel_channel_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType":{"f":""},"createChannel_channel_channelType":{"u":"response_createChannel_channel_channelType"}}};

var wrapResponseConverterMap = {
  response_createChannel_channel_channelType: RescriptRelay_Internal.wrapUnion,
  "DecidrNodeId.RelayAppSync": DecidrNodeId.RelayAppSync.serialize
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"createChannel_channel_numberOfUnreadMessages":{"b":""},"createChannel_channel_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType":{"f":""},"createChannel_channel_channelType":{"u":"response_createChannel_channel_channelType"}}};

var responseConverterMap = {
  response_createChannel_channel_channelType: unwrap_response_createChannel_channel_channelType,
  "DecidrNodeId.RelayAppSync": DecidrNodeId.RelayAppSync.parse
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var wrapRawResponseConverter = {"__root":{"createChannel_channel_numberOfUnreadMessages":{"b":""},"createChannel_channel_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_View_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_Table_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_Table_defaultView_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_Row_table_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_Row_table_defaultView_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_Row_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_RowView_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_Column_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_ColumnView_view_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_ColumnView_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_ColumnView_columnId":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_CellResource_rowId":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_CellResource_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_CellResource_columnId":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_CellResource_cellView_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType":{"u":"rawResponse_createChannel_channel_channelType_ResourceChannel_appResource_resourceType"},"createChannel_channel_channelType_ResourceChannel_appResource_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType":{"u":"rawResponse_createChannel_channel_channelType"}}};

var wrapRawResponseConverterMap = {
  "DecidrNodeId.RelayAppSync": DecidrNodeId.RelayAppSync.serialize,
  rawResponse_createChannel_channel_channelType_ResourceChannel_appResource_resourceType: RescriptRelay_Internal.wrapUnion,
  rawResponse_createChannel_channel_channelType: RescriptRelay_Internal.wrapUnion
};

function convertWrapRawResponse(v) {
  return RescriptRelay.convertObj(v, wrapRawResponseConverter, wrapRawResponseConverterMap, null);
}

var rawResponseConverter = {"__root":{"createChannel_channel_numberOfUnreadMessages":{"b":""},"createChannel_channel_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_View_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_Table_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_Table_defaultView_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_Row_table_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_Row_table_defaultView_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_Row_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_RowView_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_Column_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_ColumnView_view_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_ColumnView_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_ColumnView_columnId":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_CellResource_rowId":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_CellResource_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_CellResource_columnId":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType_CellResource_cellView_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType_ResourceChannel_appResource_resourceType":{"u":"rawResponse_createChannel_channel_channelType_ResourceChannel_appResource_resourceType"},"createChannel_channel_channelType_ResourceChannel_appResource_id":{"c":"DecidrNodeId.RelayAppSync"},"createChannel_channel_channelType":{"u":"rawResponse_createChannel_channel_channelType"}}};

var rawResponseConverterMap = {
  "DecidrNodeId.RelayAppSync": DecidrNodeId.RelayAppSync.parse,
  rawResponse_createChannel_channel_channelType_ResourceChannel_appResource_resourceType: unwrap_rawResponse_createChannel_channel_channelType_ResourceChannel_appResource_resourceType,
  rawResponse_createChannel_channel_channelType: unwrap_rawResponse_createChannel_channel_channelType
};

function convertRawResponse(v) {
  return RescriptRelay.convertObj(v, rawResponseConverter, rawResponseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: variablesConverterMap,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  wrapRawResponseConverter: wrapRawResponseConverter,
  wrapRawResponseConverterMap: wrapRawResponseConverterMap,
  convertWrapRawResponse: convertWrapRawResponse,
  rawResponseConverter: rawResponseConverter,
  rawResponseConverterMap: rawResponseConverterMap,
  convertRawResponse: convertRawResponse
};

function channelTypeEnum_decode($$enum) {
  if ($$enum === "TableResource" || $$enum === "RowViewResource" || $$enum === "RowResource" || $$enum === "Group" || $$enum === "ColumnViewResource" || $$enum === "ColumnResource" || $$enum === "CellResource" || $$enum === "ViewResource") {
    return $$enum;
  }
  
}

function channelTypeEnum_fromString(str) {
  return channelTypeEnum_decode(str);
}

var Utils = {
  channelTypeEnum_decode: channelTypeEnum_decode,
  channelTypeEnum_fromString: channelTypeEnum_fromString
};

var node = ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "channelType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "model"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "relayConnectionsToUpdate"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceId"
},
v6 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "channelType",
        "variableName": "channelType"
      },
      {
        "kind": "Variable",
        "name": "model",
        "variableName": "model"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "organizationId",
        "variableName": "organizationId"
      },
      {
        "kind": "Variable",
        "name": "resourceId",
        "variableName": "resourceId"
      },
      {
        "kind": "Literal",
        "name": "visibility",
        "value": "Public"
      }
    ],
    "kind": "ObjectValue",
    "name": "channel"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "model",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfUnreadMessages",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = [
  (v7/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "View",
  "kind": "LinkedField",
  "name": "defaultView",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "columnId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SpacesChannelMutations_createChannelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "CreateChannelPayload",
        "kind": "LinkedField",
        "name": "createChannel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Channel",
            "kind": "LinkedField",
            "name": "channel",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "channelType",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AppResource",
                        "kind": "LinkedField",
                        "name": "appResource",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "resourceType",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "SpacesChannelResourceType_resourceType"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "ResourceChannel",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "SpacesChannelMutations_createChannelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "CreateChannelPayload",
        "kind": "LinkedField",
        "name": "createChannel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Channel",
            "kind": "LinkedField",
            "name": "channel",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "channelType",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AppResource",
                        "kind": "LinkedField",
                        "name": "appResource",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "resourceType",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isResourceType"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  (v13/*: any*/)
                                ],
                                "type": "Table",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v12/*: any*/),
                                "type": "View",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Table",
                                    "kind": "LinkedField",
                                    "name": "table",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v7/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Row",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v12/*: any*/),
                                "type": "RowView",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v14/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isHidden",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "View",
                                    "kind": "LinkedField",
                                    "name": "view",
                                    "plural": false,
                                    "selections": (v12/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "ColumnView",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "rowId",
                                    "storageKey": null
                                  },
                                  (v14/*: any*/),
                                  {
                                    "alias": "cellView",
                                    "args": null,
                                    "concreteType": "View",
                                    "kind": "LinkedField",
                                    "name": "view",
                                    "plural": false,
                                    "selections": (v12/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "CellResource",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v12/*: any*/),
                                "type": "Node",
                                "abstractKey": "__isNode"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v12/*: any*/),
                                "type": "Column",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "ResourceChannel",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "channel",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "relayConnectionsToUpdate"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "ChannelEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bc3904786dc777f5a6af69c855c681ac",
    "id": null,
    "metadata": {},
    "name": "SpacesChannelMutations_createChannelMutation",
    "operationKind": "mutation",
    "text": "mutation SpacesChannelMutations_createChannelMutation(\n  $organizationId: ID!\n  $name: String!\n  $model: String\n  $channelType: ChannelTypeEnum!\n  $resourceId: ID\n) {\n  createChannel(channel: {organizationId: $organizationId, name: $name, model: $model, visibility: Public, channelType: $channelType, resourceId: $resourceId}) {\n    channel {\n      id\n      name\n      model\n      numberOfUnreadMessages\n      channelType {\n        __typename\n        ... on ResourceChannel {\n          appResource {\n            resourceType {\n              __typename\n              ...SpacesChannelResourceType_resourceType\n              ... on Node {\n                __isNode: __typename\n                __typename\n                id\n              }\n              ... on Column {\n                id\n              }\n              ... on Row {\n                id\n              }\n              ... on RowView {\n                id\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment SpacesCache_columnView on ColumnView {\n  columnId\n  isHidden\n}\n\nfragment SpacesChannelResourceType_resourceType on ResourceType {\n  __isResourceType: __typename\n  __typename\n  ... on Table {\n    id\n    defaultView {\n      id\n    }\n  }\n  ... on View {\n    id\n  }\n  ... on Row {\n    id\n    table {\n      defaultView {\n        id\n      }\n      id\n    }\n  }\n  ... on RowView {\n    id\n  }\n  ... on ColumnView {\n    ...SpacesCache_columnView\n    view {\n      id\n    }\n  }\n  ... on CellResource {\n    rowId\n    columnId\n    cellView: view {\n      id\n    }\n  }\n}\n"
  }
};
})());

var wrap_response_createChannel_channel_channelType = RescriptRelay_Internal.wrapUnion;

var wrap_rawResponse_createChannel_channel_channelType_ResourceChannel_appResource_resourceType = RescriptRelay_Internal.wrapUnion;

var wrap_rawResponse_createChannel_channel_channelType = RescriptRelay_Internal.wrapUnion;

export {
  Types ,
  unwrap_response_createChannel_channel_channelType ,
  wrap_response_createChannel_channel_channelType ,
  unwrap_rawResponse_createChannel_channel_channelType_ResourceChannel_appResource_resourceType ,
  wrap_rawResponse_createChannel_channel_channelType_ResourceChannel_appResource_resourceType ,
  unwrap_rawResponse_createChannel_channel_channelType ,
  wrap_rawResponse_createChannel_channel_channelType ,
  Internal ,
  Utils ,
  node ,
}
/* node Not a pure module */
